import { useTranslation } from "react-i18next";

export default function ActivitiesSection() {
  const { t } = useTranslation();

  const activities = [
    {
      number: "01",
      icon: "ri-calendar-event-line",
      titleKey: "activities_item1_title",
      textKey: "activities_item1_text",
    },
    {
      number: "02",
      icon: "ri-team-line",
      titleKey: "activities_item2_title",
      textKey: "activities_item2_text",
    },
    {
      number: "03",
      icon: "ri-slack-line",
      titleKey: "activities_item3_title",
      textKey: "activities_item3_text",
    },
  ];

  return (
    <section id="activities" className="w-full bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left: Text + Image */}
          <div>
            <p className="text-[#BF9B5E] text-xs font-semibold tracking-[0.3em] uppercase mb-4">
              {t("activities_label")}
            </p>
            <h2 className="text-[#1a1a1a] text-4xl md:text-5xl font-bold leading-tight mb-8">
              {t("activities_title")}
            </h2>
            <div className="w-full h-[320px] overflow-hidden mb-8">
              <img
                src="https://public.readdy.ai/ai/img_res/1e4741c0707e650c9f630b34cb0c77a4.jpg"
                alt="Community meetup"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="text-gray-500 text-base italic leading-relaxed border-l-4 border-[#BF9B5E] pl-5">
              {t("activities_note")}
            </p>
          </div>

          {/* Right: Activity cards */}
          <div className="flex flex-col gap-8 mt-4 lg:mt-16">
            {activities.map((item) => (
              <div key={item.number} className="flex items-start gap-6">
                <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-[#f8f6f2]">
                  <i className={`${item.icon} text-[#BF9B5E] text-2xl`} />
                </div>
                <div>
                  <p className="text-[#BF9B5E] text-xs font-bold tracking-widest mb-1">{item.number}</p>
                  <h3 className="text-[#1a1a1a] text-lg font-semibold mb-2">{t(item.titleKey)}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{t(item.textKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
